import React from "react";
import "./About.css";
import { ImHtmlFive2 } from "react-icons/im";
import { TbBrandCss3 } from "react-icons/tb";
import { TbBrandBootstrap } from "react-icons/tb";
import { SiTailwindcss } from "react-icons/si";
import { FaReact } from "react-icons/fa";
import { TbBrandJavascript } from "react-icons/tb";
import { FaNodeJs } from "react-icons/fa";
import { SiMongodb } from "react-icons/si";
import { SiExpress } from "react-icons/si";
import { SiMysql } from "react-icons/si";

const About = () => {
  return (
    <section className="container mx-auto px-11 py-16 bg-base-500" id="about">
        <h3 className="text-center text-5xl text-white text-accent font-serif font-bold">ABOUT ME</h3>
      <h5 className="text-3xl py-16 text-white">I am a quick learner. I have 1 year experienced. Web development is my Goal. My Skills are Here:</h5>
      <div className="container grid grid-cols-1 lg:grid-cols-2 about-container text-xl text-white font-serif">
        <div className="about-fronted">
          <h3>Frontend Development</h3>
          <div className="grid grid-cols-1 lg:grid-cols-2">
            <article className="about-details my-3">
              <ImHtmlFive2 className="about-icon" />
              <div>
                <h4>HTML</h4>
                <small className="text-light">Experienced</small>
              </div>
            </article>
            <article className="about-details my-3">
              <TbBrandCss3 className="about-icon" />
              <div>
                <h4>CSS3</h4>
                <small className="text-light">Experienced</small>
              </div>
            </article>
            <article className="about-details my-3">
              <TbBrandBootstrap className="about-icon" />
              <div>
                <h4>BOOTSTRAP</h4>
                <small className="text-light">Experienced</small>
              </div>
            </article>
            <article className="about-details my-3">
              <SiTailwindcss className="about-icon" />
              <div>
                <h4>TAILWIND CSS</h4>
                <small className="text-light">Experienced</small>
              </div>
            </article>
            <article className="about-details my-3">
              <TbBrandJavascript className="about-icon" />
              <div>
                <h4>JAVASCRIPT</h4>
                <small className="text-light">Experienced</small>
              </div>
            </article>
            <article className="about-details my-3">
              <FaReact className="about-icon" />
              <div>
                <h4>REACT JS</h4>
                <small className="text-light">Experienced</small>
              </div>
            </article>
          </div>
        </div>
        <div className="about-backend">
          <h3>Backend Development</h3>
          <div className="grid grid-cols-1 lg:grid-cols-2">
            <article className="about-details my-3">
              <FaNodeJs className="about-icon" />
              <div>
                <h4>NODE JS</h4>
                <small className="text-light">Intermediate</small>
              </div>
            </article>
            <article className="about-details my-3">
              <SiMongodb className="about-icon" />
              <div>
                <h4>MONGO DB</h4>
                <small className="text-light">Intermediate</small>
              </div>
            </article>
            <article className="about-details my-3">
              <SiMysql className="about-icon" />
              <div>
                <h4>MY SQL</h4>
                <small className="text-light">Basic</small>
              </div>
            </article>
            <article className="about-details my-3">
              <SiExpress className="about-icon" />
              <div>
                <h4>EXPRESS JS</h4>
                <small className="text-light">Intermediate</small>
              </div>
            </article>
          </div>
        </div>
      </div>
    </section>
  );
};

export default About;
